const MASK_PROCESSOR_TOKEN_MASK_LENGTH = 30;

export function maskPlaidProcessorToken(token: string): string {
  if (!token) {
    return '';
  }

  const base = token.replace(/./g, 'X');

  return base.substring(0, MASK_PROCESSOR_TOKEN_MASK_LENGTH);
}
